export const DEFAULT_PAGE_TITLE = 'noble roast dev';

export const BAG_STATUSES_ARR = ['initialized', 'in_stock', 'roasting', 'finished'];

export const BAG_STATUSES = {
    INITIALIZED: 'initialized',
    IN_STOCK: 'in_stock',
    ROASTING: 'roasting',
    FINISHED: 'finished'
};

export const BATCH_STATUSES_ARR = ['initialized', 'in_progress', 'completed', 'in_stock', 'finished', 'write_off'];

export const BATCH_STATUSES = {
    INITIALIZED: 'initialized',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    IN_STOCK: 'in_stock',
    FINISHED: 'finished',
    WRITE_OFF: 'write_off'
};

export const USER_ROLES = {
    ADMIN: 'admin',
    ROASTER: 'roaster',
    PICKER: 'picker',
    INVENTOR: 'inventor',
};

export const BAG_MINIMAL_WEIGHT = 2;

export const INITIAL_VALUE_SELECT = {
    label: '',
    value: ''
};

export const PACK_STATUSES_ARR = ['initialized', 'in_progress', 'completed', 'finished'];

export const PACK_STATUSES = {
    INITIALIZED: 'initialized',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FINISHED: 'finished'
};

export const ORDER_STATUSES_ARR = ['received', 'collected', 'sent'];

export const ORDER_STATUSES = {
    RECEIVED: 'received',
    COLLECTED: 'collected',
    SENT: 'sent'
};

export const MAINTENANCE_STATUSES_ARR = ['pending', 'completed'];

export const MAINTENANCE_STATUSES = {
    PENDING: 'pending',
    COMPLETED: 'completed'
};

export const MAINTENANCE_TYPE_ARR = ['count', 'day', 'hour'];
export const MAINTENANCE_TYPE = {
    COUNT: 'count',
    DAY: 'day',
    HOUR: 'hour'
};
